import '../plugins/openClosePlugin';
import MobileNav from '../plugins/mobileNav';

// open-close init
const initCategoryOpenClose = () => {
  jQuery('.js-category-openClose').openClose({
    activeClass: 'active',
    opener: '.opener',
    slider: '.js-slide',
    animSpeed: 400,
    effect: 'slide',
  });
};

const initMobileFiter = () => {
  const body = document.querySelector('html');
  const activeClass = 'filter-active';
  const options = {
    activeClass: 'filter-show',
    btnOpenerSelector: '.filter-panel .opener',
    hideOnClickOutside: false,
    outSideSelector: '',

    onShow: () => {
      body.classList.add(activeClass);
    },
    onHide: () => {
      body.classList.remove(activeClass);
    },
  };

  const filterHolder = document.querySelector('.products-filter');
  const filter = new MobileNav(filterHolder, options);
  filter.init();
};

export {initCategoryOpenClose, initMobileFiter};
